<template>
    <div class="mui-content">
		<div class="pd20">
			<h3 class="loginTitle">登录</h3>
			<div class="mui-input-row">
				<input type="text" class="muiInput mui-input-clear" placeholder="请输入手机号码" autocomplete="off" 
					id="tel" maxlength="11"/>
				<br></br>
			</div>
			
			<button type="button" class="mui-btn mui-btn-primary mui-btn-block mui-disabled"
				id="getCode" @click="goToGetCode()">获取验证码</button>
		</div>
	</div>	
</template>
<script>
	import { ChangePwdSendSMS } from '@/request/api';
    export default{
    	data: function(){
			return {
				openid:'',
			}
		},
    	mounted() {
    		this.openid = this.$route.query ;
    		console.log(this.openid );
    		var _this = this;
            mui('.mui-input-row input').input(); 
			//绑定inuput 事件 判断输入的是否是正确的手机号码
			$("#tel").bind('input',function(){
				var tel = $(this).val();
				if(tel){
					if(_this.isMobileTel(tel)){
						$("#getCode").removeClass("mui-disabled");
					}else{
						$("#getCode").addClass("mui-disabled")
						if(!$(".mui-toast-container").html()){
							mui.toast('请输入正确的手机号码');
						}
					}
				}else{
					if(!$(".mui-toast-container").html()){
						mui.toast('手机号码不可为空');
					}
					
					$("#getCode").addClass("mui-disabled")
				}
			});
			//为清空 绑定点击事件。
			mui('#tel')[0].addEventListener('focus', function(){
		　　　　　mui(".mui-icon-clear")[0].addEventListener('tap',function(){
		　　　　　　　$("#getCode").addClass("mui-disabled");
		　　　　 });
			});
      	},
      	methods:{
        	goToGetCode(elem){
        		if(!$(elem).hasClass("mui-disabled")){
        			if($("#tel").val()){
    					ChangePwdSendSMS({     
					    	"phone": $("#tel").val(),     
					   	}).then(res => {
					    	// 获取数据成功后的其他操作
					    	if(res.result =='true'){
					    		this.$router.push({
					    			path: '/sendCode',
					    			query: {
									    "tel": $("#tel").val(),
									    "msgCode": res.UserKey,
									    "openid":this.openid.openid
									}
					    		});
					    	}
					    	else{
					    		mui.toast(res.description,{ duration:'long'});	
					    	}
//					    }).catch(err => {   
//				   			console.log(err);
				  		})  
        			}
//      			
        		}
        	},
        	isMobileTel(mobile){
        		var mreg =/^1[3|4|5|6|7|8|9]{1}[0-9]{1}[0-9]{8}$/;
		        if(!mreg.test(mobile)){
		            return false;
		        }
		        return true;
        	}
        }
    }
</script>
<style>
     @import '../common/css/public.css';
</style>


// WEBPACK FOOTER //
// src/pages/login.vue